import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import  Dropzone from 'dropzone'; 
import { AuthenticationService, CoreService } from '../services';



@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent implements OnInit, AfterViewInit {
  

  @Input() url:any;
  @Input() msg: any;
  @Input() doctype:any;

  @Input() contextId:any;
  @Input() contextType:any;
  @Input() dropZoneId: any;
  @Input() fileType:any;
  @Input() uploadType:any;
  @Input() img_width;
  @Input() img_height;
  Height:any;

  public dropZone: any;

 // public dropzoneId: any  = "mydropzone";



  @Output() docUploaded = new EventEmitter<any>();
  @Output() docimport = new EventEmitter<any>();
  @Output() docError = new EventEmitter<any>();


  constructor(private authenticationService: AuthenticationService,
    private coreService:CoreService) { }

  ngOnInit() { 
    
  }


  ngAfterViewInit(): void { 
    this.dropZoneInit ();
  }


  dropZoneInit() {

  var token  = this.authenticationService.getAuthToken ();
   
  var ele  = document.getElementById (this.dropZoneId); 
  if (!ele){
    return;
  }

 

  this.dropZone = new Dropzone("div#"+ this.dropZoneId, { 
    url: this.url,
    uploadMultiple: false,
    dictDefaultMessage: this.msg,
    maxFiles: 5, 
    headers: {
      contextid: this.contextId,
      contexttype: this.contextType,
      doctype:  this.doctype,
      token: token, 
      appname:this.coreService.getAppName (),
      usertype: this.coreService.getUserType ()

      
    },
    accept:  (file, done) => {   
      var name = file.name;
      if (this.uploadType == "zip"){
        var parts = name.split  (".");
        if (parts.length <= 1){
          this.docError.emit("Please upload valid zip file."); 
          done ("Please upload valid zip file."); 
          return;
        }

        if ( parts [parts.length-1].toLowerCase().indexOf("zip") <0){
          this.docError.emit("Please upload valid zip file."); 
          done ("Please upload valid zip file."); 
          return;
        }
      }
      //console.log ("what is file type ", this.fileType, "what is file", file, " type:",  file.type,  "uplaod " , this.uploadType);
     if(this.fileType.indexOf(file.type) >=0 || file.type.indexOf(this.fileType)){      
      
      if(this.uploadType ==="import" || this.uploadType == "zip"){ 
        done ();
      }
      else if (this.uploadType ==="imagelogo" || this.uploadType ==="imagebanner" || this.uploadType === "examos"){
     
        done();         
     
      } 

    }
      else{        
        if(this.uploadType ==="import"){
        this.docError.emit("Please upload valid excel file, allowed only Xlxs file type.");            
        done ("Please upload valid excel file, allowed only Xlxs file type");
        }else if(this.uploadType ==="zip"){
          this.docError.emit("Please upload valid zip file.");            
          done ("Please upload valid zip file."); 
        }
        else{
          this.docError.emit("Please upload valid image file, allowed only image file type( Jpg,Jpeg,Png)");            
        done ("Please upload valid image file, allowed only image file type( Jpg,Jpeg,Png)");
        }
      } 
      
    }
  });


   
  this.dropZone.on("success", (file, response) => {    
    if(file.type =="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
      this.docimport.emit (response);
    }else if (response.documentid){      
      this.docUploaded.emit (response);
    }else {
      this.docUploaded.emit (response);
    }
  }); 
  

  this.dropZone.on("complete", (file, a, b) => { 

    if (file && file.xhr){
      var response = file.xhr.response;
      if (response){
        response = JSON.parse (response);
       // console.log ("COMPLETE >.ehre is respomsen .....", response);
        if (response.status == "error"){
          this.docError.emit("Error: " + response.message);     
        }
      }
    }
   
    
    this.dropZone.removeFile (file);
  }); 

}
}
